import React from 'react';
import PropTypes from 'prop-types';
import ImportExcelLot from 'Lots/Containers/import-excel-lot';
import Translate from 'components/translate';
import ImportSection from './project-add-edit-import-section';

const importOptions = [
  {
    key: 'lot',
    name: <Translate translateKey='lot' plurals capitalize />,
    icon: 'icon-lots-ic'
  },
  {
    key: 'rfs',
    name: 'Requests for service/Punch list',
    icon: 'icon-standard-requests-ic'
  },
  {
    key: 'workOrder',
    name: 'Work orders',
    icon: 'icon-work-orders-ic'
  },
  {
    key: 'purchaseOrder',
    name: 'Purchase orders',
    icon: 'icon-purchase-orders-ic'
  }
];

class ProjectAddEditImport extends React.Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    projectId: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOptionImport: null
    };
  }

  renderImportOptions = () => {
    return importOptions.map(option => {
      return (
        <div
          className='import-option-item'
          key={option.key}
          onClick={() => {
            this.setState({ selectedOptionImport: option });
          }}
        >
          <i className={option.icon} />
          <span>{option.name}</span>
        </div>
      );
    });
  };

  renderImportSection = selectedOptionImport => {
    const { match, projectId, history } = this.props;

    if (selectedOptionImport && selectedOptionImport.key === 'lot') {
      return (
        <ImportExcelLot match={match} projectId={projectId} history={history} />
      );
    }

    if (selectedOptionImport && selectedOptionImport.key) {
      return (
        <ImportSection
          sectionKey={selectedOptionImport.key}
          projectId={projectId}
        />
      );
    }

    return null;
  };

  render() {
    const { selectedOptionImport } = this.state;

    return (
      <div className='import-wrapper'>
        {!selectedOptionImport ? (
          <div>
            <div className='info-note'>
              <span style={{ fontSize: 25, marginRight: 10 }}>
                <i className='fa fa-info-circle' aria-hidden='true' />
              </span>
              <span>
                If you import data from scratch, follow this order: Lots{' '}
                <i className='fa fa-long-arrow-right' aria-hidden='true' />{' '}
                Requests for service/Punch list{' '}
                <i className='fa fa-long-arrow-right' aria-hidden='true' /> Work
                orders{' '}
                <i className='fa fa-long-arrow-right' aria-hidden='true' />{' '}
                Purchase orders.
              </span>
            </div>

            <div className='import-options'>{this.renderImportOptions()}</div>
          </div>
        ) : (
          <div>
            <ul className='breadcrumb'>
              <li>
                <span
                  className='span-primary-color'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    this.setState({ selectedOptionImport: null });
                  }}
                >
                  Import
                </span>
              </li>
              <li className='breadcrumb-siteone-li'>
                {selectedOptionImport.name}
              </li>
            </ul>
            {this.renderImportSection(selectedOptionImport)}
          </div>
        )}
      </div>
    );
  }
}

export default ProjectAddEditImport;



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-import.js